// extracted by mini-css-extract-plugin
export default {"delimiter":"delimiter---oeJVL","job":"job---ptSo7","jobHeader":"jobHeader---acOlf"};